import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Check, Lock, ChevronLeft, ChevronRight, Zap, Shield, Clock } from 'lucide-react';
const comboImages = ['https://cdn.magicpatterns.com/uploads/7QpeG7P1s6uqumkQX9u2qs/Diseno_sin_titulo-59.png', 'https://cdn.magicpatterns.com/uploads/hdk4seSnU8X7BoYQzPghLi/Diseno_sin_titulo-58.png', 'https://cdn.magicpatterns.com/uploads/tMZG5rVVPzna4TQY49K55p/mockup_principal_derecho_360.png'];
function MiniCarousel() {
  const [current, setCurrent] = useState(0);
  const total = comboImages.length;
  const prev = () => setCurrent(c => (c - 1 + total) % total);
  const next = () => setCurrent(c => (c + 1) % total);
  return <div className="relative py-6 px-8" data-id="element-83">
      <div className="overflow-hidden rounded-xl" data-id="element-84">
        <img src={comboImages[current]} alt={`Producto ${current + 1}`} className="w-full max-w-sm mx-auto drop-shadow-xl transition-opacity duration-300" data-id="element-85" />
      </div>
      <button onClick={prev} className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-white rounded-full shadow border border-slate-200 flex items-center justify-center hover:bg-slate-50" data-id="element-86">
        <ChevronLeft className="h-4 w-4 text-slate-700" data-id="element-87" />
      </button>
      <button onClick={next} className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-white rounded-full shadow border border-slate-200 flex items-center justify-center hover:bg-slate-50" data-id="element-88">
        <ChevronRight className="h-4 w-4 text-slate-700" data-id="element-89" />
      </button>
      <div className="flex justify-center gap-1.5 mt-3" data-id="element-90">
        {comboImages.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`h-1.5 rounded-full transition-all duration-300 ${i === current ? 'w-6 bg-blue-900' : 'w-1.5 bg-slate-300'}`} data-id="element-91" />)}
      </div>
    </div>;
}
function TrustBar() {
  return <div className="flex flex-wrap justify-center gap-6 mt-5 text-sm" data-id="element-92">
      <div className="flex items-center gap-2 text-slate-500" data-id="element-93">
        <Lock className="h-4 w-4 text-green-600" data-id="element-94" />
        <span data-id="element-95">Pago 100% seguro</span>
      </div>
      <div className="flex items-center gap-2 text-slate-500" data-id="element-96">
        <Zap className="h-4 w-4 text-amber-500" data-id="element-97" />
        <span data-id="element-98">Acceso inmediato</span>
      </div>
      <div className="flex items-center gap-2 text-slate-500" data-id="element-99">
        <Shield className="h-4 w-4 text-blue-600" data-id="element-100" />
        <span data-id="element-101">Garantía 7 días</span>
      </div>
    </div>;
}
export function PricingSection() {
  const handlePurchase = () => {
    window.location.href = 'https://checkout.rincondigital.shop/cart/53324019826963:1';
  };
  const handleComboPurchase = () => {
    window.location.href = 'https://checkout.rincondigital.shop/cart/53852935880979:1';
  };
  return <section id="pricing" className="py-20 bg-gradient-to-b from-slate-900 via-blue-950 to-slate-900 relative overflow-hidden" data-id="element-102">
      {/* Background texture */}
      <div className="absolute inset-0 opacity-5" data-id="element-103">
        <div className="absolute top-20 left-10 w-72 h-72 bg-amber-400 rounded-full blur-3xl" data-id="element-104" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-400 rounded-full blur-3xl" data-id="element-105" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-106">
        <div className="text-center mb-12" data-id="element-107">
          <span className="inline-block bg-amber-400 text-blue-900 text-xs font-extrabold px-4 py-1.5 rounded-full uppercase tracking-widest mb-4" data-id="element-108">
            ⚡ Oferta por tiempo limitado
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-3" data-id="element-109">
            Elegí tu acceso
          </h2>
          <p className="text-blue-200 text-lg" data-id="element-110">
            Todo el año de Derecho resuelto. Hoy.
          </p>
        </div>

        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 items-start" data-id="element-111">
          {/* --- PLAN 1 --- */}
          <div className="bg-white rounded-3xl overflow-hidden shadow-2xl" data-id="element-112">
            <div className="bg-blue-900 px-6 py-5 text-center" data-id="element-113">
              <p className="text-amber-400 text-xs font-bold uppercase tracking-widest mb-1" data-id="element-114">
                Plan Base
              </p>
              <h3 className="text-xl font-extrabold text-white" data-id="element-115">DERECHO 360</h3>
              <p className="text-blue-200 text-sm mt-1" data-id="element-116">
                Sistema completo de por vida
              </p>
            </div>
            <div className="px-4 pt-4" data-id="element-117">
              <img src="https://cdn.magicpatterns.com/uploads/tMZG5rVVPzna4TQY49K55p/mockup_principal_derecho_360.png" alt="Derecho 360" className="w-full max-w-xs mx-auto drop-shadow-xl" data-id="element-118" />
            </div>
            <div className="p-6" data-id="element-119">
              <ul className="space-y-3 mb-6" data-id="element-120">
                {['Sistema completo DERECHO 360', 'Clases listas paso a paso', 'Actividades para adolescentes', 'BONO 1: Mapa Anual de Derecho', 'BONO 2: Evaluaciones Prácticas', 'BONO 3: Casos Reales', 'Actualizaciones futuras gratis'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-121">
                    <div className="bg-green-100 rounded-full p-1 flex-shrink-0" data-id="element-122">
                      <Check className="h-3.5 w-3.5 text-green-600" data-id="element-123" />
                    </div>
                    <span className="text-slate-700 text-sm font-medium" data-id="element-124">
                      {item}
                    </span>
                  </li>)}
              </ul>
              <div className="text-center mb-5 bg-slate-50 rounded-2xl py-4 px-3" data-id="element-125">
                <p className="text-slate-400 text-sm line-through mb-1" data-id="element-126">
                  $49.990
                </p>
                <p className="text-5xl font-extrabold text-blue-900" data-id="element-127">$19.990</p>
                <p className="text-green-600 text-xs font-bold mt-1" data-id="element-128">
                  Ahorrás $30.000
                </p>
              </div>
              <Button onClick={handlePurchase} size="xl" fullWidth className="shadow-lg" data-id="element-129">
                QUIERO ACCESO AHORA
              </Button>
              <TrustBar data-id="element-130" />
            </div>
          </div>

          {/* --- PLAN 2: Combo --- */}
          <div className="bg-white rounded-3xl overflow-hidden shadow-2xl ring-4 ring-amber-400 relative" data-id="element-131">
            <div className="absolute -top-px left-1/2 -translate-x-1/2 bg-amber-400 text-blue-900 text-xs font-extrabold px-5 py-1.5 rounded-b-xl uppercase tracking-wider whitespace-nowrap z-10" data-id="element-132">
              🔥 Más popular · Mejor valor
            </div>
            <div className="bg-gradient-to-r from-blue-900 to-blue-800 px-6 py-5 text-center pt-8" data-id="element-133">
              <p className="text-amber-400 text-xs font-bold uppercase tracking-widest mb-1" data-id="element-134">
                Combo Completo
              </p>
              <h3 className="text-lg font-extrabold text-white leading-tight" data-id="element-135">
                MEGAPACK + EVALUACIONES + CLASES SALVAVIDAS
              </h3>
              <p className="text-blue-200 text-sm mt-1" data-id="element-136">
                Todo junto. Todo el año resuelto.
              </p>
            </div>

            <MiniCarousel data-id="element-137" />

            <div className="p-6 pt-0" data-id="element-138">
              <ul className="space-y-3 mb-6" data-id="element-139">
                {['Todo el sistema DERECHO 360', '✨ Evaluaciones Listas para usar', '✨ Clases Salvavidas para emergencias', 'Actividades para adolescentes', 'Casos reales para debatir', 'BONO 1: Mapa Anual de Derecho', 'BONO 2: Evaluaciones Prácticas', 'BONO 3: Casos Reales', 'Actualizaciones futuras gratis'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-140">
                    <div className="bg-green-100 rounded-full p-1 flex-shrink-0" data-id="element-141">
                      <Check className="h-3.5 w-3.5 text-green-600" data-id="element-142" />
                    </div>
                    <span className="text-slate-700 text-sm font-medium" data-id="element-143">
                      {item}
                    </span>
                  </li>)}
              </ul>
              <div className="text-center mb-5 bg-amber-50 rounded-2xl py-4 px-3 border border-amber-200" data-id="element-144">
                <p className="text-slate-400 text-sm line-through mb-1" data-id="element-145">
                  $69.990
                </p>
                <p className="text-5xl font-extrabold text-blue-900" data-id="element-146">$25.990</p>
                <p className="text-green-600 text-xs font-bold mt-1" data-id="element-147">
                  Ahorrás $44.000
                </p>
              </div>
              <Button onClick={handleComboPurchase} size="xl" fullWidth className="shadow-lg" data-id="element-148">
                QUIERO EL COMBO COMPLETO
              </Button>
              <TrustBar data-id="element-149" />
            </div>
          </div>
        </div>

        {/* Guarantee — integrated into dark section */}
        <div className="mt-12 max-w-2xl mx-auto text-center" data-id="element-150">
          <div className="inline-flex items-center gap-3 bg-white/10 backdrop-blur border border-white/20 rounded-2xl px-8 py-5" data-id="element-151">
            <Shield className="h-10 w-10 text-green-400 flex-shrink-0" data-id="element-152" />
            <div className="text-left" data-id="element-153">
              <p className="text-white font-bold text-base" data-id="element-154">
                Garantía de Satisfacción Total
              </p>
              <p className="text-blue-200 text-sm mt-0.5" data-id="element-155">
                Probalo 7 días. Si no cumple tus expectativas, te devolvemos el
                100% de tu dinero. Sin preguntas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}